<script>
  import {API_VILLAGE, API_EMPLOYEE} from '../../common/api'
  import VillageSelect from '../../components/VillageSelect'

  export default {
    name: 'VillageUpdate',
    props: ["village_id"],
    data() {
      return {
        villageForm: {
          id: '',
          name: '',
          parent_id: 0,
          admin_id: ''
        },
        rules: {
          name: [
            {required: true, message: '小区名不能为空', trigger: 'blur'}
          ],
          admin_id: [
            {required: true, message: '请选择抄表员', trigger: 'blur'}
          ],
        },
        adminList: [],
        parentVillageId: 0
      }
    },
    created() {
      this.getVillage()
      this.getAdminList()
    },
    methods: {
      getVillage() {
        this.isLoading = true;
        this.$http.GET(API_VILLAGE + '/' + this.village_id, null,
          res => {
            this.villageForm = res.result.data;
            this.parentVillageId = res.result.data.parent_id;
            this.isLoading = false
          }, err => {
            this.isLoading = false;
            this.$message.error(err.msg);
          }
        )
      },
      updateVillage(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            let params = {
              parent_id: this.parentVillageId,
              name: this.villageForm.name,
              admin_id: this.villageForm.admin_id
            };
            this.$http.PUT(API_VILLAGE + '/' + this.village_id, params,
              res => {
                this.loading = false;
                this.$emit('updateVillageSuccess')
              }, err => {
                this.loading = false;
                this.$message.error(err.msg)
              })
          }
        });
      },
      selectVillage(data) {
        this.parentVillageId = data
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      getAdminList() {
        this.$http.GET(API_EMPLOYEE, {role_id : 4},
          res => {
            this.adminList = res.result.list;
          }, err => {
            this.$message.error(err.msg);
          }
        )
      }
    },
    components: {
      VillageSelect
    }
  }
</script>

<template>
  <div class="table_container">
    <el-form ref="villageForm" :model="villageForm" :rules="rules" size="small" @submit.native.prevent
             label-width="100px">
      <el-form-item label="小区名称" prop="name">
        <el-input v-model="villageForm.name" placeholder="请输入小区名" clearable class="form_input_width"></el-input>
      </el-form-item>
      <el-form-item label="上级分类">
        <VillageSelect @selectVillageId='selectVillage' v-bind:defaultVillageId='parentVillageId'
                       style="width: 350px"></VillageSelect>
      </el-form-item>
      <el-form-item label="抄表员" prop="admin_id">
        <el-select v-model="villageForm.admin_id" placeholder="请选择抄表员" style="width: 350px">
          <el-option
            v-for="item in adminList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="warning" @click="resetForm('villageForm')" size="small">重 置</el-button>
        <el-button type="primary" @click="updateVillage('villageForm')" size="small">确 定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style lang="scss" scoped>

  @import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/village/VillageUpdate.vue